import { NgModule, Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

/**
 * @description
 *
 * Trust Html being send and bypass sanitizer security
 *
 * @usageNotes
 *
 * To use with innerHtml when the html source is trusted
 * ```
 * <div [innerHtml]="userHtml | safeHtml"></div>
 * ```
 *
 * @ngModule TrustHtmlPipeModule
 */
@Pipe({
    name: "trustHtml",
    standalone: false,
})
export class TrustHtmlPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    public transform(value: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}

@NgModule({
    declarations: [TrustHtmlPipe],
    exports: [TrustHtmlPipe],
})
export class TrustHtmlPipeModule {}
